export default __webpack_public_path__ + "static/threedoorways-e11018168c6eb236940ad99db5d94325.gif";